import React, { useState, useRef } from 'react';
import {
    Box,
    Typography,
    Paper,
    Divider,
    Button,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Alert,
    CircularProgress,
    TextField,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import {
    getFirestore,
    collection,
    query,
    where,
    getDocs,
    Timestamp,
} from 'firebase/firestore';
import { toast } from 'react-toastify';
import Fiananceheader from './Fiananceheader';
import { useReactToPrint } from 'react-to-print';

const db = getFirestore();

function Loancustreport() {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [reportGenerated, setReportGenerated] = useState(false);
    const [error, setError] = useState('');

    const printRef = useRef();

    const handleGetReport = async () => {
        setError('');
        if (!fromDate || !toDate) {
            setError('Please select both From Date and To Date.');
            return;
        }

        const fromTimestamp = Timestamp.fromDate(new Date(fromDate));
        const toTimestamp = Timestamp.fromDate(new Date(`${toDate}T23:59:59`));

        setLoading(true);
        try {
            const customersQuery = query(
                collection(db, 'fianancecustomers'),
                where('addeddate', '>=', fromTimestamp),
                where('addeddate', '<=', toTimestamp)
            );

            const querySnapshot = await getDocs(customersQuery);
            const customersList = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            setCustomers(customersList);
            setReportGenerated(true);
        } catch (err) {
            console.error('Error fetching customer report:', err);
            toast.error('Failed to generate report.');
            setError('Failed to fetch data. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
      <html>
        <head>
          <title> Report</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            th { background-color: #1976d2; color: #fff; }
            h2,h4 { margin: 5px 0; }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);
        printWindow.document.close();
        printWindow.print();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box p={3}>
            <Fiananceheader />
            <Paper sx={{ p: 4, borderRadius: '5px' }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, textAlign: 'center', color: '#1976d2', mb: 3 }}>
                    🧑‍💼 कर्जदार रिपोर्ट 
                </Typography>
                <Divider sx={{ mb: 3 }} />

                <Grid container  mb={3} className="row">
                    <Grid item xs={12} sm={4} className="col-sm-2 mb-4">
                        <TextField
                            fullWidth
                            size="small"
                            label="या तारखेपासून "
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} className="col-sm-2 mb-4">
                        <TextField
                            fullWidth
                            size="small"
                            label="या तारखेपर्यंत "
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} className="col-sm-2 mb-4">
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleGetReport}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : 'Get Report'}
                        </Button>
                    </Grid>
                </Grid>

                {error && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                        {error}
                    </Alert>
                )}

                {reportGenerated && customers.length === 0 && !loading && (
                    <Alert severity="info" sx={{ mb: 3 }}>
                        No customers found for the selected date range.
                    </Alert>
                )}

                {customers.length > 0 && (
                    <Box sx={{ mt: 3, textAlign: 'right' }}>
                        <Button
                            variant="outlined"
                            onClick={handlePrint}
                            startIcon={<PrintIcon />}
                        >
                            Print Report
                        </Button>
                    </Box>
                )}

                <div ref={printRef} style={{ padding: '16px' }}>
                    {customers.length > 0 && (
                        <>
                            <Typography variant="h6" align="center" sx={{ display: 'none', '@media print': { display: 'block' } }}>
                                 Report from {new Date(fromDate).toLocaleDateString()} to {new Date(toDate).toLocaleDateString()}
                            </Typography>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Sr. No.</TableCell>
                                            <TableCell>कर्जदार आयडी </TableCell>
                                            <TableCell>कर्जदाराचे नाव </TableCell>
                                            <TableCell>मोबाइल  </TableCell>
                                            <TableCell>पत्ता</TableCell>
                                            <TableCell>दिनांक </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {customers
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((customer, index) => (
                                                <TableRow key={customer.id}>
                                                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                    <TableCell>{customer.custID}</TableCell>
                                                    <TableCell>{customer.name}</TableCell>
                                                    <TableCell>{customer.mobile}</TableCell>
                                                    <TableCell>{customer.address}</TableCell>
                                                    <TableCell>
                                                        {customer.addeddate && new Date(customer.addeddate.seconds * 1000).toLocaleDateString()}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={customers.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                    )}
                </div>
            </Paper>
        </Box>
    );
}

export default Loancustreport;